import React from 'react';

const Loading = () => {
    return (
        <div>
            <h1 className="text-center"><i className="fa fa-spinner fa-spin" aria-hidden="true"></i>&nbsp;Loading...</h1>
        </div>
    )
}

export default Loading